import { ReactNode, useReducer, useRef } from "react";

import { DispatchContext, reducer, State, StateContext } from "./reducer";

export function WindowsProvider({
    children,
    initialState: customInitialState,
}: {
    children: ReactNode;
    initialState?: State;
}) {
    const effectiveInitialState = customInitialState ?? {};
    const [state, dispatch] = useReducer(reducer, effectiveInitialState);
    const lazyValue = useRef(state);
    lazyValue.current = state;

    return (
        <StateContext.Provider value={state}>
            <DispatchContext.Provider value={dispatch}>{children}</DispatchContext.Provider>
        </StateContext.Provider>
    );
}
